import { Button } from "primereact/button";
import "./ButtonCommon.css";

const ButtomCommon = (props: any) => {
  const onClickButton = () => {
    if (props.eventClick) props.eventClick();
    };

    //console.log('props', props);

  return (
    <>
      {props.disabled ? (
        // <Button label={props.label} className='p-button-warning button-fitprenda-common font-fitprenda-button w-100 h-100' onClick={props.eventClick} disabled/>
        <Button
                  label={props.label}
                  style={props.Styles}
                  className={
                      (props.isOutline
                          ? "p-button-outlined button-outline-fitprenda-common font-fitprenda-button-outline"
                          : "button-fitprenda-common font-fitprenda-button") +
                      " p-button-warning h-100" + ((props.Styles?.width) ? '' : 'w-100')
                  }
                  onClick={() => onClickButton()}
                  disabled
                  
        />
      ) : (
        // <Button label={props.label} className='p-button-warning button-fitprenda-common font-fitprenda-button w-100 h-100' onClick={props.eventClick} />
                  <Button
                      label={props.label}
                      style={props.Styles}
                      className={
                          (props.isOutline
                              ? "p-button-outlined button-outline-fitprenda-common font-fitprenda-button-outline"
                              : "button-fitprenda-common font-fitprenda-button") +
                          " p-button-warning h-100" + ((props.Styles?.width) ? '' : 'w-100')
                      }
                      onClick={() => onClickButton()}
                      badge={(props.Badge ? props.Badge : "")} badgeClassName="p-badge-warning"
        />
      )}
    </>
  );
};

export default ButtomCommon;
